import React from 'react';

import './Dashboard.css';
import GeneralUtils from "../../shared/utils/GeneralUtils";
import MerchantMenuService from "../../shared/service/MerchantMenuService";
import MerchantBranchService from "../../shared/service/MerchantBranchService";
import {
    isMerchantMenuApiSuccess,
    normalizeMenuListResponse,
    expandPurchaseRequisitionWebMenus,
    expandPurchaseRequisitionMobileMenus,
    resolveMenuHref,
    resolveMenuIcon,
    sortMenusByDescription,
    sortMenusForSection
} from "./dashboardMenuUtils";
import DashboardMenuIcon from "./DashboardMenuIcon";


export default class DashboardMerchant extends React.Component {
    constructor(props) {
        super(props);
        this.state = {menuList: []};
        this.merchantMenuService = new MerchantMenuService();
        this.merchantBranchService = new MerchantBranchService();


    }

    componentDidMount = () => {
        var userGroup = GeneralUtils.getUserGroup();
        if (GeneralUtils.isMobile()) {
            this.merchantBranchService.getStoreInfo(localStorage.getItem("merchantBranchId")).then(response => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type) && !GeneralUtils.isNullOrEmpty(response.mobileView) && response.mobileView == "REPORTS") {
                            this.merchantMenuService.findMenus().then(data => {
                                if (isMerchantMenuApiSuccess(data)) {
                                    const menus = normalizeMenuListResponse(data);
                                    const filteredData = menus.filter(item => item.id === 3 || item.id === 4 || item.id === 302 || item.id === 401 || item.id === 403);
                                    this.setState({menuList: filteredData});
                                }

                            });
                        } else {
                            this.merchantMenuService.findMenus().then(data => {
                                if (isMerchantMenuApiSuccess(data)) {
                                    const menus = normalizeMenuListResponse(data);
                                    if (userGroup == "MERCHANT_BRANCH_USER") {
                                        const filteredData = menus.filter(item => (item.id === 9 || item.id === 903 || item.id === 904));
                                        this.setState({menuList: expandPurchaseRequisitionMobileMenus(filteredData)})
                                    } else {
                                        this.setState({menuList: expandPurchaseRequisitionMobileMenus(menus)})
                                    }


                                }

                            });
                        }

                    }
                }
            )


        } else {
            this.merchantMenuService.findMenus().then(data => {
                if (isMerchantMenuApiSuccess(data)) {
                    const menus = expandPurchaseRequisitionWebMenus(normalizeMenuListResponse(data));

                    if (userGroup == "MERCHANT_BRANCH_ADMIN") {
                        const filteredData = menus.filter(item => item.id !== 903 && item.id !== 904);
                        this.setState({menuList: filteredData})
                    } else if (userGroup == "MERCHANT_BRANCH_USER") {
                        const filteredData = menus.filter(item => (item.id !== 903 && item.id !== 9 && item.id !== 904));
                        this.setState({menuList: filteredData})
                    } else {
                        this.setState({menuList: menus})
                    }


                }

            });
        }


        this.merchantMenuService.getPrivileges().then(data => {
            if (!GeneralUtils.isNullOrEmpty(data) && GeneralUtils.isNullOrEmpty(data.type)) {
                localStorage.setItem("hsmPrivilegeList", JSON.stringify(data));
            }

        });

    }

    getMenuList() {
        return Array.isArray(this.state.menuList) ? this.state.menuList : [];
    }

    getParentMenus() {
        return sortMenusByDescription(
            this.getMenuList().filter(item => GeneralUtils.isNullOrEmpty(item.parentId))
        );
    }

    getChildMenus(parent) {
        return sortMenusForSection(
            parent,
            this.getMenuList().filter(item => item.parentId == parent.id)
        );
    }

    renderMenuTile(item) {
        const href = resolveMenuHref(item);
        const iconClass = resolveMenuIcon(item);
        return (
            <a key={item.id} href={href} className="dashboard-launcher__tile">
                <span className="dashboard-launcher__tile-icon" aria-hidden="true">
                    <DashboardMenuIcon iconClass={iconClass}/>
                </span>
                <span className="dashboard-launcher__tile-label">{item.description}</span>
            </a>
        );
    }

    render() {
        const parents = this.getParentMenus();
        if (parents.length === 0) {
            return null;
        }

        return (
            <div className="dashboard-launcher">
                {parents.map(parent => {
                    const children = this.getChildMenus(parent);
                    if (children.length === 0) {
                        return null;
                    }
                    return (
                        <section key={parent.id} className="dashboard-launcher__section">
                            <h2 className="dashboard-launcher__section-title">{parent.description}</h2>
                            <div className="dashboard-launcher__grid">
                                {children.map(child => this.renderMenuTile(child))}
                            </div>
                        </section>
                    );
                })}
            </div>
        );
    }


}
